import { buildResult, pass, skip } from "../../buildResult";
import { defineTest } from "../../defineTest";
import {
  CHATGPT_LAMBDA,
  formatDurationMs,
  findRunChatgptMaxDurationMs,
  resolveTrace,
  SUMMARIZATION_SLA_MS,
} from "../../helper/trace";

export default defineTest(
  "trace_summarization_sla",
  "Summarization SLA (3 min)",
  ({ trace, fetchErrors }) => {
    const resolved = resolveTrace({ trace, fetchErrors });
    if (!resolved.ok) return resolved.result;

    const { events } = resolved;
    if (events.length === 0) return skip("Trace has no events");

    const run = findRunChatgptMaxDurationMs(events);

    if (!run) {
      return skip(
        `Requires ${CHATGPT_LAMBDA} START and END events in trace`
      );
    }

    const { startMs, endMs, durationMs } = run;

    if (durationMs < 0) {
      return buildResult({
        warnings: [
          `Could not measure summarization SLA: ${CHATGPT_LAMBDA} END is before START`,
        ],
        developerNotes: [
          `RunChatgpt START: ${startMs}`,
          `RunChatgpt END: ${endMs}`,
        ].join("\n"),
      });
    }

    const durationLabel = formatDurationMs(durationMs);
    const slaLabel = formatDurationMs(SUMMARIZATION_SLA_MS);

    if (durationMs > SUMMARIZATION_SLA_MS) {
      return buildResult({
        warnings: [
          `Violated 3 minute SLA (${durationLabel} from ${CHATGPT_LAMBDA} START to END; limit ${slaLabel})`,
        ],
        developerNotes: [
          `RunChatgpt START: ${startMs}`,
          `RunChatgpt END: ${endMs}`,
          `elapsed: ${durationMs} ms`,
        ].join("\n"),
      });
    }

    return pass(
      `Within 3 minute SLA (${durationLabel} from ${CHATGPT_LAMBDA} START to END)`
    );
  }
);
